"use client";
import { useRouter as useNextRouter, useParams } from "next/navigation";
import { startPageTransition } from "@/utils/pageLoader.utils";

interface RouterOptions {
  autoHideLoading?: boolean;
  scroll?: boolean;
}

const useCRouter = () => {
  const router = useNextRouter();
  const { locale } = useParams();

  const push = (path: string, options?: RouterOptions, refresh: boolean = false) => {
    const { autoHideLoading = true, ...rest } = options || {};
    startPageTransition(autoHideLoading);
    router.push(`/${locale}${path}`, rest);
    if (refresh) {
      router.refresh();
    }
  };

  return {
    ...router,
    nextPush: router.push,
    push,
  };
};

export default useCRouter;
